import { ConfirmationModal } from 'seagull';
import { PdfViewer } from "../PdfViewer/PdfViewer";
import styles from "./pdfViewerModal.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const PdfViewerModal = _ref => {
  let {
    title,
    getFileUrl,
    onClose,
    'data-testid': testId
  } = _ref;
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    overflowContent: true,
    contentPadding: "small",
    width: "800px",
    height: "calc(100% - 128px)",
    title: title,
    onCloseButtonClick: onClose,
    "data-testid": testId,
    content: /*#__PURE__*/_jsx("div", {
      className: styles.pdfViewerWrapper,
      children: /*#__PURE__*/_jsx(PdfViewer, {
        getFileUrl: getFileUrl,
        hideSinglePageLoader: true
      })
    })
  });
};